import service from '@/util/service';

// notice
export const getNoticeList = params => service.jsonGet('/api/business/project/invite/message', params);

export const handleNotice = params => service.jsonPost('/api/business/project/message/handle', params);



// WEBPACK FOOTER //
// ./src/api/notice/index.js